import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./CategoryJs.css";
import SuggestedCategory from "../../components/Layouts/Sidebar/Left/Category/Content/SugesstedCategory";
import ContentLoader from "../ContentLoader";
import { serverInfo } from "../../App";

const Category = () => {

  const { imageCdnUrl } = useContext(serverInfo);

  const [category_list, setCategoryList] = useState([]);
  const [loading, setLoading] = useState(true);

  const headerStyle = {
    BorderStyle: {
      borderRadius: "5px",
    },
  };

  useEffect(() => {
    axios.get(`/api/user/selected/category`).then((res) => {
      if (res.status === 200) {
        setCategoryList(res.data.userCategory);
      }
      setLoading(false);
    });
  }, []);

  var viewCategory = "";

  if (loading) {
    return (
      <>
        <ContentLoader />
      </>
    );
  } else {
    viewCategory = category_list.map((item, index) => {
      return (
        <>
          <div className="containerSa col-sm-6 col-md-6 col-lg-4 mb-3">
            <div className="card p-2 card-bg1">
              <img
                src={item.image == null ?'https://d35vkepp4dfq5y.cloudfront.net/demo/3502688.png': imageCdnUrl+item.image}
                className="ImgCat"
                alt={imageCdnUrl + item.image}
                height="220px"
              />

              <Link to={`/category-view/${item.slug}`}>
                <div className="CatBgS ">
                  <h6 className="centeredASd fw-bold">
                    <i className="fas fa-film"></i>&nbsp;
                    {item.name}
                  </h6>
                </div>
              </Link>
            </div>
          </div>
        </>
      );
    });
  }

  return (
    <>
      <div className="col-md-12 mt-3">
        <div className="row mb-4">{viewCategory}</div>
        <SuggestedCategory headerStyle={headerStyle} />
      </div>
    </>
  );
};

export default Category;
